import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {Base} from 'diagram-js/lib/model';
import {select, Store} from "@ngrx/store";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {NodeCopied, NodesClipboardReset} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {selectNodeCreationInfoById} from "@ispm-client/modules/bpmn-modeler/store/selectors";
import {take} from "rxjs/operators";
import {NodeCreationResult} from "@ispm-client/modules/bpmn-modeler/models/node-creation-result";
import {TreatmentPlanSelectorResult} from "@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result";
import {CopiedBpmnNodeCreatedResult} from "@ispm-client/modules/bpmn-modeler/models/copied-bpmn-node-created-result";
import {cloneDeep} from 'lodash';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {CurationUtils} from "../../../../app/curation/utils/curation-utils";

export class CopyNodeHandler implements CommandHandler {

  constructor(private store$: Store<State>) {
  }

  execute(context): Base[] {
    return [context.element];
  }

  postExecute(context): any {

    this.store$.pipe(select(selectNodeCreationInfoById(this.getIdsForCreationInfoCalculation(context.element))), take(1))
      .subscribe(nodesCreationInfo => {
        if (nodesCreationInfo && nodesCreationInfo.length > 0 && nodesCreationInfo[0]) {
          const copiedObject: CopiedBpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult> =
          this.calculateCopiedNodeCreationInfo(nodesCreationInfo[0], context.element.type);
          // in case we copy a neighborhood entry we need to pass also the neighborhood head data
          if (nodesCreationInfo[1]) {
            copiedObject.childrenNodes = [this.calculateCopiedNodeCreationInfo(nodesCreationInfo[1], NodeType.neighborhood_head)];
          }

          const clipboard = {
            copiedObject: copiedObject,
            isContainNeighborhood: ModelingUtil.getNodeType(context.element) === NodeType.neighborhood_entry
          };
          this.store$.dispatch(new NodesClipboardReset({}));
          this.store$.dispatch(new NodeCopied({clipboard: clipboard}));
        }
      });
  }

  private calculateCopiedNodeCreationInfo(nodeCreationInfo: any, nodeType: NodeType) : CopiedBpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>{
    nodeCreationInfo.nodeType = nodeType;
    const copiedObject: CopiedBpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult> = cloneDeep(nodeCreationInfo);
    copiedObject.data = CurationUtils.setCopyRelatedEntity(copiedObject.data);
    return copiedObject;
  }

  private getIdsForCreationInfoCalculation(element) {
    if (ModelingUtil.isNeighborhoodEntryNode(element)) {
      const neighborhoodHead = element.outgoing[0].target;
      return [element.id, neighborhoodHead.id];
    }
    return [element.id]
  }
}
